import React, { useState } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function ShippingMethodSelector({ value, onChange }) {
  const [openDialog, setOpenDialog] = useState(false);
  const navigate = useNavigate();

  const handleSelect = (e) => {
    const selected = e.target.value;

    if (selected === "משלוח") {
      setOpenDialog(true);
      onChange("");
    } else {
      onChange("איסוף עצמי");
    }
  };
  const handleApproveDelivery = () => {
    onChange("משלוח");
    setOpenDialog(false);
  };

  return (
    <Box sx={{ mt: 3, display: "flex", alignItems: "center", gap: 2 }}>
      <FormControl sx={{ minWidth: 260 }}>
        <InputLabel>בחר שיטת משלוח</InputLabel>

        <Select
          value={value}
          label="בחר שיטת משלוח"
          onChange={handleSelect}
          sx={{ direction: "rtl" }}
        >
          <MenuItem value="איסוף עצמי">איסוף עצמי מהחנות</MenuItem>
          <MenuItem value="משלוח">משלוח</MenuItem>
        </Select>
      </FormControl>

      {/* {value && (
        <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>
          {value}
        </Typography>
      )} */}

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        dir="rtl"
      >
        <DialogTitle>משלוח</DialogTitle>

        <DialogContent>
          <Typography sx={{ fontSize: "18px", mt: 1 }}>
            כרגע המשלוחים הם לירושלים והסביבה בלבד.
          </Typography>

          <Typography sx={{ fontSize: "18px", mt: 1 }}>
            התשלום ייגבה בנפרד.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2 }}>
          <Button
            variant="outlined"
            onClick={() => navigate("/shipping-policy")}
          >
            למחירון משלוחים
          </Button>

          <Button
            variant="contained"
            sx={{ backgroundColor: "#D81B60" }}
            onClick={handleApproveDelivery}
          >
            אישור
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}